import React, { useState, useEffect } from "react";
import { Box, Button, Menu, MenuItem, TableBody, Typography } from "@mui/material";
import { FiDownload, FiEye, FiSearch } from "react-icons/fi"; // Make sure to run: npm install react-icons
import axios from "axios";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Modal from "@mui/material/Modal"

export default function SearchAndProjectFilter() {
  // --- 1. State & API Logic (Your code, optimized) ---
  const [projectName, setProjectNames] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);

  const [selectedProject, setSelectedProject] = useState("All Projects");
  const [searchTerm, setSearchTerm] = useState("");
  
  // Billing & Modal State
  const [billingData, setBillingData] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

      const companyId=sessionStorage.getItem("companyId");


// --- 2. API Calls ---
  useEffect(() => {
    // Fetch Projects
    const getProjectNames = () => {
      axios
        .get("https://buildfastvapi.emedha.in/project/api/v1/get-basic")
        .then((res) => {
          setProjectNames(res.data.data || []);
        })
        .catch((err) => console.log(err));
    };
    getProjectNames();

    // Fetch Customer Billings
    // Replace this URL with your actual endpoint for the customer_billing table
    axios
      .get("https://buildfastvapi.emedha.in/pmaster/api/v1/get-customer-billing") 
      .then((res) => {
        if (res.data.status === 200) {
          setBillingData(res.data.data || []);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // --- 3. Filter Logic ---
// --- 3. Filter Logic ---
  useEffect(() => {
    const userType = sessionStorage.getItem("userType");
    const projectNamesSession = sessionStorage.getItem("ProjectName");
    const currentCompanyId = parseInt(sessionStorage.getItem("companyId")); // Get company ID

    const filteredProj = projectName.filter((project) => {
      // 1. PRIMARY CHECK: Does this project belong to the user's company?
      // If it doesn't match the company ID, immediately hide it.
      if (project.company_id !== currentCompanyId) {
        return false;
      }

      // 2. SECONDARY CHECK: Role-based restrictions
      // If they are Admin/CRM Head, restrict them to their specific assigned project
      if (userType === "Admin" || userType === "CRM Head") {
        return project.ProjectName === projectNamesSession;
      }

      // 3. Default: If they belong to the company and have no role restrictions, 
      // show them all projects FOR THIS COMPANY ONLY.
      return true; 
    });

    setFilteredProjects(filteredProj);
  }, [projectName]);


  // Filter Table Data based on Search Term AND Selected Project Dropdown
const filteredBillingData = billingData.filter((item) => {
  const searchString = searchTerm.toLowerCase();

  const matchesSearch =
    (item.customerName || "").toLowerCase().includes(searchString) ||
    (item.ucin || "").toLowerCase().includes(searchString) ||
    (item.tower || "").toLowerCase().includes(searchString) ||
    (item.ProjectName || "").toLowerCase().includes(searchString);

  // ✅ Only allow projects from filteredProjects list
  const allowedProjects = filteredProjects.map(p => p.ProjectName);

  const matchesProject =
    selectedProject === "All Projects"
      ? allowedProjects.includes(item.ProjectName)   // 👈 FIX HERE
      : item.ProjectName === selectedProject;

 const matchesCompany =
  !item.company_id || Number(item.company_id) === Number(companyId);

  return matchesSearch && matchesProject && matchesCompany;
});

  // --- 4. Handlers ---
  const handleViewClick = (customer) => {
    setSelectedCustomer(customer);
    setViewModalOpen(true);
  };


  // --- 2. Premium UI Render ---
  return (
   <Box sx={{ width: "100%", p: { xs: 1, md: 1 } }}>
      
      {/* --- Search & Filter Bar (Your Figma Design) --- */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: "16px",
          width: "100%",
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            width: "100%",
            height: "45px",
            backgroundColor: "#F4F7FE",
            borderRadius: "8px",
            padding: "0 16px",
            border: "1px solid #4318ff", // Active border look
            transition: "all 0.2s ease",
            "&:focus-within": {
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.05)",
            },
          }}
        >
          <FiSearch style={{ color: "#A3AED0", fontSize: "18px", marginRight: "12px" }} />
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)} // Connects to search state
            placeholder="Search by customer, UCIN, project, block, tower..."
            style={{
              width: "100%", border: "none", outline: "none", backgroundColor: "transparent",
              fontSize: "14px", color: "#2B3674", fontWeight: "500",
            }}
          />
        </Box>

        <Box sx={{ width: { xs: "100%", md: "250px" } }}>
      <select
  value={selectedProject}
  onChange={(e) => setSelectedProject(e.target.value)}
  style={{
    width: "100%", height: "45px", padding: "0 16px", fontSize: "14px", color: "#2B3674",
    backgroundColor: "#ffffff", border: "1px solid #E0E5F2", borderRadius: "8px",
    outline: "none", cursor: "pointer", fontWeight: "600", transition: "all 0.2s ease",
  }}
  onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
  onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
>
  <option value="All Projects">All Projects</option>
  
  {/* Cleaned up: No longer needs .filter() here because state is already filtered! */}
  {filteredProjects.map((project, index) => (
    <option key={index} value={project.ProjectName}>
      {project.ProjectName}
    </option>
  ))}
</select>
        </Box>
      </Box>

      {/* --- Premium Data Table --- */}
      <TableContainer sx={{ borderRadius: "12px", border: "1px solid #E0E5F2", overflowX: "auto", backgroundColor: "#ffffff", boxShadow: "0px 4px 15px rgba(0,0,0,0.02)" }}>
        <Table sx={{ minWidth: 1000 }} stickyHeader>
        <TableHead>
  <TableRow sx={{ background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)" }}>
    {["Project", "UCIN", "Customer Name", "Tower / Flat", "Payment Type", "Total Value", "Date", "Actions"].map((head, i) => (
      <TableCell 
        key={i} 
        sx={{ 
          color: "#4318ff", // White text for visibility on the dark gradient
          fontWeight: "700", 
          fontSize: "13px", 
          padding: "16px",
          borderBottom: "1px solid #E0E5F2", // Apply the border directly to the cell!
        }}
      >
        {head}
      </TableCell>
    ))}
  </TableRow>
</TableHead>
          <TableBody>
            {filteredBillingData.length > 0 ? (
              filteredBillingData.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674" }}>{row.ProjectName}</TableCell>
                  <TableCell sx={{ fontSize: "13px", color: "#4318ff", fontWeight: "600" }}>{row.ucin}</TableCell>
                  <TableCell sx={{ fontSize: "13px", color: "#2B3674" }}>{row.customerName}</TableCell>
                  <TableCell sx={{ fontSize: "13px", color: "#707eae" }}>{row.flatNo || row.tower}</TableCell>
                  <TableCell sx={{ fontSize: "13px" }}>
                    <span style={{ padding: "4px 10px", backgroundColor: "#F4F7FE", borderRadius: "6px", color: "#4318ff", fontWeight: "700" }}>
                      {row.loan}
                    </span>
                  </TableCell>
                  <TableCell sx={{ fontSize: "13px", color: "#2B3674", fontWeight: "700" }}>₹{row.totalValue}</TableCell>
                  <TableCell sx={{ fontSize: "13px", color: "#A3AED0" }}>{row.date1 || "N/A"}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: "10px" }}>
                      {/* View Action */}
                      <div onClick={() => handleViewClick(row)} style={{ backgroundColor: "#E9EDF7", padding: "8px", borderRadius: "8px", cursor: "pointer", transition: "0.2s" }} title="View Details">
                        <FiEye style={{ color: "#4318ff", fontSize: "16px" }} />
                      </div>
                      {/* Download Action */}
                      <div style={{ backgroundColor: "#F0FDF4", padding: "8px", borderRadius: "8px", cursor: "pointer", transition: "0.2s" }} title="Download Invoice">
                        <FiDownload style={{ color: "#059669", fontSize: "16px" }} />
                      </div>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ padding: "40px", color: "#A3AED0", fontWeight: "600" }}>
                  No billing records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* --- Detailed Installment View Modal --- */}
      <Modal open={viewModalOpen} onClose={() => setViewModalOpen(false)} sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
        <Box sx={{ backgroundColor: "#ffffff", borderRadius: "16px", width: "100%", maxWidth: "800px", maxHeight: "90vh", overflowY: "auto", p: { xs: 3, md: 4 }, outline: "none", boxShadow: "0px 10px 40px rgba(0,0,0,0.1)" }}>
          
          <Typography sx={{ color: "#1B2559", fontWeight: "800", fontSize: "20px", mb: 3 ,display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
            Installment Breakdown: <span style={{ color: "#4318ff" }}>{selectedCustomer?.customerName}</span> ({selectedCustomer?.ucin})
          </Typography>

          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: "20px" }}>
            {/* Loop through all 10 possible installments dynamically */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => {
              const instAmt = selectedCustomer?.[`installment${num}`];
              
              // Only render the card if the installment exists and is not zero
              if (instAmt && instAmt !== "0") {
                return (
                  <Box key={num} sx={{ p: 2, border: "1px dashed #E0E5F2", borderRadius: "12px", backgroundColor: "#F8F9FF" }}>
                    <Typography sx={{ color: "#4318ff", fontWeight: "800", fontSize: "14px", mb: 1, textTransform: "uppercase" }}>
                      Installment {num}
                    </Typography>
                    
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                      <Typography sx={{ color: "#A3AED0", fontSize: "12px" }}>Amount:</Typography>
                      <Typography sx={{ color: "#2B3674", fontSize: "13px", fontWeight: "700" }}>₹{instAmt}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                      <Typography sx={{ color: "#A3AED0", fontSize: "12px" }}>Date:</Typography>
                      <Typography sx={{ color: "#2B3674", fontSize: "13px", fontWeight: "600" }}>{selectedCustomer?.[`date${num}`] || "Pending"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                      <Typography sx={{ color: "#A3AED0", fontSize: "12px" }}>Invoice:</Typography>
                      <Typography sx={{ color: "#2B3674", fontSize: "13px", fontWeight: "600" }}>{selectedCustomer?.[`invoice${num}`] || "N/A"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, pt: 1, borderTop: "1px solid #E0E5F2" }}>
                      <Typography sx={{ color: "#A3AED0", fontSize: "12px" }}>GST ({selectedCustomer?.[`gstPercentage${num}`] || 0}%):</Typography>
                      <Typography sx={{ color: "#2B3674", fontSize: "13px", fontWeight: "700" }}>₹{selectedCustomer?.[`gstTotal${num}`] || "0"}</Typography>
                    </Box>
                  </Box>
                );
              }
              return null;
            })}
          </Box>

          <Button onClick={() => setViewModalOpen(false)} sx={{ mt: 4, width: "100%", height: "45px", backgroundColor: "#F4F7FE", color: "#4318ff", fontWeight: "700", borderRadius: "8px", "&:hover": { backgroundColor: "#E9EDF7" } }}>
            Close Details
          </Button>
        </Box>
      </Modal>

    </Box>
  );
}